import create from 'zustand';
import produce from 'immer';

const PARENT_MARK_INITIAL = {
	children: [],
};

export const useParentMarkStore = create(set => ({
	...PARENT_MARK_INITIAL,

	// Set active grade
	onActive: (childId, gradeId) => set(produce(state => {
		const child = state.children.find(child => child.id === childId);
		child.active = gradeId;
		child.view = 'summary';
	})),

	// Set view
	onView: (childId, view) => set(produce(state => {
		const child = state.children.find(child => child.id === childId);
		child.view = view;
	})),

	// Initialize student's mark state
	onInit: ({ children }) => set(produce(state => {
		state.children = children?.map(({ grades, courses, takes, marks, ...child }) => ({
			...child,
			grades,
			courses,
			takes,
			marks,
			active: grades.find(g => g.state === 'active')?.id || grades[0]?.id || 0,
			view: 'summary'
		}));
	})),

	// Reset store to initial state
	onReset: () => set({
		...PARENT_MARK_INITIAL
	})
}));